var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckedOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 4278"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 421",
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#FF9027"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 714",
    d: "M4 8L6.5 10.5L11 6",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckedOrange);
export default __webpack_public_path__ + "static/media/CheckedOrange.4ac51a53ed78ee5fbd368ecd31f64f8f.svg";
export { ForwardRef as ReactComponent };